import { useMemo } from 'react';
import type { PropsWithChildren } from 'react';
import type React from 'react';

import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

import { useUtilityContext } from '@change-corgi/core/react/utilityContext';

import stripeConfig from 'config/stripe.json';

export const StripeLoader: React.FC<PropsWithChildren<EmptyProps>> = ({ children }) => {
	const utilityContext = useUtilityContext();

	const environment = utilityContext.environment.getEnvironment();
	// we actually want a promise here
	// eslint-disable-next-line react-hooks/use-memo
	const stripePromise = useMemo(async () => loadStripe(stripeConfig.key[environment]), [environment]);

	return <Elements stripe={stripePromise}>{children}</Elements>;
};
